import { Chip, Stack } from '@mui/material';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import VerticalBookingCardBase from '../common/VerticalBookingCardBase';
import { extractUpgradeSymbols } from '../../../../util/upgradeSymbolsHelper';
import { formatOrderedResourcesByGroup } from '../../../../util/orderedResourcesDisplay';

const neutralCardColor = '#cccccc';

function BookingCardGolfv2({
  booking,
  handleOpenModal,
  durationByIdMs,
  orderedResourcesConfig,
  wave,
}) {
  const upgradeSymbols = extractUpgradeSymbols(booking);
  const orderedLine = formatOrderedResourcesByGroup(booking, orderedResourcesConfig?.nameById, {
    maxParts: 2,
  });

  // Slot metadata can represent either staggered group starts or sequential resource switches.
  const isResourceSwitch = Boolean(wave?.type === 'resourceSwitch' || wave?.isResourceSwitch);
  const switchInfo = isResourceSwitch ? wave?.resourceSwitch || null : null;
  const isStaggered = Boolean(!isResourceSwitch && wave && Number(wave.totalWaves) > 1);
  const isContinuation = Boolean(isResourceSwitch || (wave && wave.isFirstWave === false));
  const waveParticipants =
    wave && Number.isFinite(Number(wave.participants)) ? Number(wave.participants) : null;
  const laterWaves = Array.isArray(wave?.laterWaves) ? wave.laterWaves : [];

  const badgeParticipantCount =
    (isStaggered || isResourceSwitch) && waveParticipants != null
      ? waveParticipants
      : booking.participantCount;

  const handleCardClick = () => {
    if (handleOpenModal) {
      handleOpenModal(booking._id);
    }
  };

  return (
    <VerticalBookingCardBase
      booking={booking}
      color={neutralCardColor}
      borderStyle={isContinuation ? 'dashed' : 'solid'}
      onCardClick={handleCardClick}
      showProductInfo={false}
      showVariationInfo={false}
      iconProps={{
        upgrades: upgradeSymbols,
        manualUpgrades: [],
        participantCount: badgeParticipantCount,
        color: '#2d2d2d',
      }}
    >
      {isContinuation ? (
        <Stack
          direction='row'
          spacing={0.5}
          alignItems='center'
          sx={{ mt: 0.5, flexWrap: 'wrap', rowGap: 0.5 }}
        >
          <Chip
            size='small'
            variant='outlined'
            icon={<SubdirectoryArrowRightIcon sx={{ fontSize: 14 }} />}
            label={
              isResourceSwitch
                ? switchInfo?.toResourceName
                  ? `Wechsel zu ${switchInfo.toResourceName}`
                  : 'Ressourcenwechsel'
                : `Fortsetzung · Welle ${wave.waveIndex}/${wave.totalWaves}`
            }
            title={
              isResourceSwitch && switchInfo?.fromResourceName && switchInfo?.toResourceName
                ? `Ressourcenwechsel von ${switchInfo.fromResourceName} zu ${switchInfo.toResourceName}`
                : undefined
            }
            sx={{
              height: 20,
              maxWidth: '100%',
              fontSize: '0.68rem',
              fontWeight: 700,
              borderColor: neutralCardColor,
              '& .MuiChip-label': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'block',
              },
            }}
          />
          {wave.firstStartLabel ? (
            <Chip
              size='small'
              variant='outlined'
              label={`aus ${wave.firstStartLabel}`}
              sx={{ height: 20, fontSize: '0.68rem' }}
            />
          ) : null}
        </Stack>
      ) : (
        <>
          {isStaggered && laterWaves.length > 0 ? (
            <Stack
              direction='row'
              spacing={0.5}
              alignItems='center'
              sx={{ mt: 0.5, flexWrap: 'wrap', rowGap: 0.5 }}
            >
              <Chip
                size='small'
                color='warning'
                icon={<AccessTimeIcon sx={{ fontSize: 14 }} />}
                label={`gestaffelt · ${booking.participantCount} ges.`}
                sx={{ height: 20, fontSize: '0.68rem', fontWeight: 700 }}
              />
              {laterWaves.map(later => (
                <Chip
                  key={later.label}
                  size='small'
                  variant='outlined'
                  label={`+${later.participants} ${later.label}`}
                  sx={{ height: 20, fontSize: '0.68rem' }}
                />
              ))}
            </Stack>
          ) : null}
          {orderedLine ? (
            <div style={{ fontSize: '75%', opacity: 0.85, marginTop: 2 }}>{orderedLine}</div>
          ) : booking.pricingName ? (
            <div style={{ fontSize: '80%', opacity: 0.85, marginTop: 2 }}>{booking.pricingName}</div>
          ) : null}
          {booking.resourceId?.name && (
            <div style={{ fontSize: '80%', opacity: 0.8 }}>{booking.resourceId.name}</div>
          )}
        </>
      )}
    </VerticalBookingCardBase>
  );
}

export default BookingCardGolfv2;
